import request from '@/utils/request'

// 初始化地区
export function initArea(data){
  return request({
    url: '/admin/area/init',
    method: 'post',
    data: data
  })
}
// 查询地区列表
export function listArea(query) {
  return request({
    url: '/admin/area/list',
    method: 'get',
    params: query
  })
}

// 查询子地区列表
export function listChildArea(parentCode) {
  return request({
    url: '/admin/area/childList?parentCode='+parentCode,
    method: 'get'
  })
}

// 刷新地区缓存
export function refreshCache() {
  return request({
    url: '/admin/area/refreshCache',
    method: 'delete'
  })
}

// 根据父级编号查询地区
export function getAreaParent(areaCode) {
  return request({
    url: '/admin/area/getAreaByParent?parentCode=' + areaCode,
    method: 'get'
  })
}

//地区级联数据
export function listAreaCascader(){
  return request({
    url: '/admin/area/areaCascader',
    method: 'get'
  })
}
//根据地区编号查询地区详情
export function getDetailAddress(areaCode) {
  return request({
    url: '/admin/area/getDetailAddress?areaCode=' + areaCode,
    method: 'get'
  })
}
